module.exports = __webpack_public_path__ + "img/coming-soon.bb3e8111.png";